export const checkElementInViewport = (element: HTMLElement, threshold: number): boolean => {
  const { top, height, bottom } = element.getBoundingClientRect();
  const viewportHeight = document.documentElement.clientHeight;

  // элемент пересекается с нижней стороной вьюпорта
  if (top < viewportHeight && bottom > viewportHeight) {
    const visibleHeight = (viewportHeight - top) / height;

    return visibleHeight >= threshold;
  }

  // элемент пересекается с верхней стороной вьюпорта
  if (top < 0 && bottom > 0) {
    const visibleHeight = bottom / height;

    return visibleHeight >= threshold;
  }

  // элемент полностью помещается во вьюпорт
  return top > 0 && bottom < viewportHeight;
};
